import styled from 'styled-components';
import { Link } from 'react-router-dom'

export const CategoryPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`

export const Title = styled(Link)`
  font-size: 28px;
  margin-bottom: 25px;
  cursor: pointer;
`
export const Preview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  overflow-x: auto;
  overflow-y: clip;

  @media screen and (max-width: 1024px) {
  grid-auto-flow: column;
  grid-auto-columns: minmax(300px, 1fr);
  grid-template-columns: none;
  overflow-x: auto;
  overflow-y: clip
  }

   @media screen and (max-width: 425px) {
  grid-auto-flow: column;
  grid-auto-columns: minmax(275px, 1fr);
  grid-template-columns: none;
  overflow-x: auto;
  overflow-y: clip
  }
`

